var SlickOverride = (function () {

  $.fn.slick.stopAuto = function () {

    var _ = this;
    $(this).on('click', '.slick-arrow, .slick-dots button', function (e) {
      var $slider = $(this).parents('.slick-initialized');
      $slider.slick(
        'slickSetOption',
        'autoplay',
        false,
        false,
      );
    });
  };

  function init() {
    $.fn.slick.stopAuto();
  }

  return {
    init: init,
  };
}());
